var map = {
	"./X33-Mall_small.jpg": 902,
	"./all-active.svg": 903,
	"./all.svg": 904,
	"./apple-watch.png": 905,
	"./b-headphone.png": 906,
	"./coin.svg": 907,
	"./delete-btn.svg": 908,
	"./iphone-13.webp": 2294,
	"./iphone-pink.png": 909,
	"./love-active.svg": 910,
	"./love.svg": 911,
	"./mobile-bg.jpg": 912,
	"./mobile-bg.webp": 2295,
	"./price-high-active.svg": 913,
	"./price-high.svg": 914,
	"./price-low-active.svg": 915,
	"./price-low.svg": 916,
	"./rewards-dnp-cn.webp": 2296,
	"./rewards-dnp.webp": 2297,
	"./shopping-cart.svg": 917,
	"./star.svg": 918,
	"./x33mall-banner-cn.jpg": 919,
	"./x33mall-banner-cn.webp": 2298,
	"./x33mall-banner-id.jpg": 920,
	"./x33mall-banner-ms.jpg": 921,
	"./x33mall-banner-ms.webp": 2299,
	"./x33mall-banner.jpg": 922,
	"./x33mall-banner.webp": 2300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;